import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import Icon from '../icon';
import messages from './messages';

type Props = {
	issue: string | undefined;
	typeName: string;
	title: string | undefined;
	iconUrl: string;
	intl: IntlShape;
};

function Summary(props: Props) {
	const {
		iconUrl,
		typeName,
		title,
		issue,
		intl: { formatMessage },
	} = props;

	return (
		<SummaryWrapper>
			<Icon src={iconUrl} alt={formatMessage(messages.iconAltText, { typeName })} />
			<IssueKey>{issue}</IssueKey>
			<Title>{title}</Title>
		</SummaryWrapper>
	);
}

Summary.defaultProps = {
	issue: undefined,
	title: undefined,
};

export default injectIntl(Summary);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Title = styled.div({
	marginLeft: token('space.100', '8px'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SummaryWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueKey = styled.div({
	marginLeft: token('space.100', '8px'),
	whiteSpace: 'nowrap',
});
